<template>
  <div>
    <b-modal
        scrollable
      id="barcode-modal"
      ref="modal"
      header-class="headerModal"
      centered
      title="Barcode"
      hide-footer
      hide-header
    >
      <canvas
        ref="barcodeCanvas"
        style="width:200px;height:100px;"
      />
    </b-modal>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import JsBarcode from 'jsbarcode';

export default {
  props: ['barcodeValue'],
  watch: {
    barcodeValue(value) {
      if (value) {
        this.generateBarcode(value);
      }
    },
  },
  mounted() {
    if (this.barcodeValue) {
      this.generateBarcode(this.barcodeValue);
    }
  },
  methods: {
    generateBarcode(value) {
      const canvas = this.$refs.barcodeCanvas;
      JsBarcode(canvas, value, {
        format: 'CODE128',
        displayValue: true,
      });
    },
  },
};
</script>

  <style scoped>
  </style>
